import { FormattedMessage } from "react-intl";

import * as Styled from "./styles";

const TicketListHeader: React.FC = () => (
  <Styled.Wrapper>
    <Styled.Cell>
      <FormattedMessage defaultMessage="First Name" />
    </Styled.Cell>
    <Styled.Cell>
      <FormattedMessage defaultMessage="Last Name" />
    </Styled.Cell>
    <Styled.Cell>
      <FormattedMessage defaultMessage="TicketID" />
    </Styled.Cell>
    <Styled.Cell>
      <FormattedMessage defaultMessage="Status" />
    </Styled.Cell>
  </Styled.Wrapper>
);

export default TicketListHeader;
